import type { DirectiveDescriptor } from '@mdxeditor/editor';

import { IFRAME_MDX_DIRECTIVE_NAME } from './iframeMdxDirectiveConstants';
import { IframeMdxDirectiveEditor } from './IframeMdxDirectiveEditor';

export const IframeMdxDirectiveDescriptor: DirectiveDescriptor = {
  name: IFRAME_MDX_DIRECTIVE_NAME,
  testNode(node) {
    return node.name === IFRAME_MDX_DIRECTIVE_NAME;
  },
  Editor: IframeMdxDirectiveEditor,
  hasChildren: false,
  attributes: [],
};
